import React from 'react'
import { Chip, Tooltip } from '@mui/material'
import { heldTooltip, isHeld } from '../../utils/codingBatches'

/** "Held" chip for a queued batch whose billed team has no AI budget left. Renders nothing for any other batch. */
const HeldChip: React.FC<{ batch: { held_reason?: string } }> = ({ batch }) => {
  if (!isHeld(batch)) return null
  return (
    <Tooltip title={heldTooltip(batch)}>
      <Chip size="small" color="warning" label="Held" data-testid="batch-held-chip" sx={{ ml: 0.5 }} />
    </Tooltip>
  )
}

export default HeldChip
